/**
 * The confirmation page's money rows. "Tax & fees" used to be everything above
 * the subtotal; the Online Service Fee now has its own line, so its AMOUNT
 * comes out of that bucket (its tax stays in it).
 */
export function splitConfirmationTotals(input: {
    readonly subtotal: number;
    readonly goodsTotal: number;
    readonly onlineServiceFee?: { readonly amount: number } | null;
}): { taxAndFees: number; onlineServiceFeeAmount: number } {
    const onlineServiceFeeAmount = Math.max(0, input.onlineServiceFee?.amount ?? 0);
    const taxAndFees = Math.max(
        0,
        Math.round((input.goodsTotal - input.subtotal - onlineServiceFeeAmount) * 100) / 100,
    );
    return { taxAndFees, onlineServiceFeeAmount };
}
